/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 10:05:42
 * @LastEditors: wning
 * @LastEditTime: 2022-12-06 10:23:46
 */
const langLabels = {
  loginBtnLabel: '登录',
  userName: '用户名',
  mima: '密码',
  userNamePlaceholder: '请输入用户名',
  mimaPlaceholder: '请输入密码',
  interface: {
    apiName: 'Interface name',
    apiUrl: 'Interface address',
    perms: 'Permission ID',
    remark: 'Interface description',
    state: 'State',
    createTime: 'Creation time',
    createBy: 'Created by',
    updateBy: 'Update persion',
    updateTime: 'Updated by',
    deptCode: 'Department Code',
    apiNamePlaceholder: 'Please enter the interface name',
    apiUrlPlaceholder: 'Please enter the interface address',
    statePlaceholder: 'Please select a status',
    permsPlaceholder: 'Please select a permission ID',
    remarkPlaceholder: 'Please enter the interface description',
    creatTimePlaceholder: 'Please select creation time',
    endTimeplaceholder: 'End time',
    startTimeplaceholder: 'start time',
    submit: 'Submit',
    save: 'Save',
    cancle: 'Cancle',
    all: 'All'
  }
}
export default langLabels
